"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadSearchResultsData = void 0;
var _fetching = require("@ori/fetching");
var _logger = require("../../../logger");
var _searchResultsPage = require("../../../queries-net/searchResultsPage");
/* istanbul ignore file @preserve */ const localLogger = _logger.mainLogger.createChild('loadSearchResultsData');
const loadSearchResultsData = async (param)=>{
    let { headers, orderBy, query, skip, graphQlNetUrl, limit, facetFiltering = [], withRelatedLinks = false } = param;
    try {
        return await (0, _fetching.fetchGraphql)({
            query: _searchResultsPage.searchResultsPageQuery,
            variables: {
                limit,
                orderBy,
                query,
                skip,
                facetFiltering,
                withRelatedLinks
            },
            url: graphQlNetUrl,
            headers,
            timeout: 10000
        });
    } catch (error) {
        localLogger.error(new Error('fetchGraphql searchResultsPageQuery', {
            cause: error
        }));
        throw error;
    }
};
exports.loadSearchResultsData = loadSearchResultsData;
